import React from 'react';

type BadgeVariant = 'success'| 'warning' | 'danger' | 'info' | 'muted' | 'accent' | 'stage-inquiry'| 'stage-requirement' | 'stage-proposal' | 'stage-approval' | 'stage-development'| 'stage-testing' | 'stage-review' | 'stage-deployment' | 'stage-maintenance' | 'priority-critical' | 'priority-high' | 'priority-medium' | 'priority-low';

interface BadgeProps {
  label: string;
  variant: BadgeVariant;
  size?: 'sm' | 'md';
  dot?: boolean;
}

const variantClasses: Record<BadgeVariant, string> = {
  success: 'bg-success/10 text-success',
  warning: 'bg-warning/10 text-warning',
  danger: 'bg-danger/10 text-danger',
  info: 'bg-primary/10 text-primary',
  muted: 'bg-muted text-muted-foreground',
  accent: 'bg-cyan/10 text-cyan',
  'stage-inquiry': 'badge-stage-inquiry',
  'stage-requirement': 'badge-stage-requirement',
  'stage-proposal': 'badge-stage-proposal',
  'stage-approval': 'badge-stage-approval',
  'stage-development': 'badge-stage-development',
  'stage-testing': 'badge-stage-testing',
  'stage-review': 'badge-stage-review',
  'stage-deployment': 'badge-stage-deployment',
  'stage-maintenance': 'badge-stage-maintenance',
  'priority-critical': 'priority-critical',
  'priority-high': 'priority-high',
  'priority-medium': 'priority-medium',
  'priority-low': 'priority-low',
};

const dotColors: Record<BadgeVariant, string> = {
  success: 'bg-success',
  warning: 'bg-warning',
  danger: 'bg-danger',
  info: 'bg-primary',
  muted: 'bg-muted-foreground',
  accent: 'bg-cyan',
  'stage-inquiry': 'bg-slate-400',
  'stage-requirement': 'bg-indigo-400',
  'stage-proposal': 'bg-amber-400',
  'stage-approval': 'bg-cyan-400',
  'stage-development': 'bg-blue-400',
  'stage-testing': 'bg-purple-400',
  'stage-review': 'bg-orange-400',
  'stage-deployment': 'bg-emerald-400',
  'stage-maintenance': 'bg-teal-400',
  'priority-critical': 'bg-red-400',
  'priority-high': 'bg-amber-400',
  'priority-medium': 'bg-blue-400',
  'priority-low': 'bg-emerald-400',
};

export default function Badge({ label, variant, size = 'sm', dot = false }: BadgeProps) {
  return (
    <span
      className={`
        inline-flex items-center gap-1.5 font-medium rounded-full
        ${size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-xs'}
        ${variantClasses[variant]}
      `}
    >
      {dot && <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${dotColors[variant]}`} />}
      {label}
    </span>
  );
}